// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vcePE","controls":"styles_controls__2ujLp","charLimit":"styles_charLimit__jd5dt","input":"styles_input__1Dvhw","send":"styles_send__1CmL8"};